/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProductRegisterSkuProductItem } from './ProductRegisterSkuProductItem';
import {
    ProductRegisterSkuProductItemFromJSON,
    ProductRegisterSkuProductItemFromJSONTyped,
    ProductRegisterSkuProductItemToJSON,
    ProductRegisterSkuProductItemToJSONTyped,
} from './ProductRegisterSkuProductItem';

/**
 * 
 * @export
 * @interface ProductRegisterSkuItem
 */
export interface ProductRegisterSkuItem {
    /**
     * SKU编码（可选；前端手动填写时传入，需全局唯一；不传则系统自动生成）
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    skuCode?: string;
    /**
     * 条形码编号
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    marketBarcode: string;
    /**
     * 条形码商品名称
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    marketProductName: string;
    /**
     * 条形码选项名
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    marketOptionName?: string;
    /**
     * 条形码选项ID
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    marketOptionId?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof ProductRegisterSkuItem
     */
    businessPlatformId?: number;
    /**
     * 货币类型，默认KRW
     * @type {string}
     * @memberof ProductRegisterSkuItem
     */
    currencyType?: string;
    /**
     * 
     * @type {Array<ProductRegisterSkuProductItem>}
     * @memberof ProductRegisterSkuItem
     */
    skuProducts: Array<ProductRegisterSkuProductItem>;
}

/**
 * Check if a given object implements the ProductRegisterSkuItem interface.
 */
export function instanceOfProductRegisterSkuItem(value: object): value is ProductRegisterSkuItem {
    if (!('marketBarcode' in value) || value['marketBarcode'] === undefined) return false;
    if (!('marketProductName' in value) || value['marketProductName'] === undefined) return false;
    if (!('skuProducts' in value) || value['skuProducts'] === undefined) return false;
    return true;
}

export function ProductRegisterSkuItemFromJSON(json: any): ProductRegisterSkuItem {
    return ProductRegisterSkuItemFromJSONTyped(json, false);
}

export function ProductRegisterSkuItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductRegisterSkuItem {
    if (json == null) {
        return json;
    }
    return {
        
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'marketBarcode': json['marketBarcode'],
        'marketProductName': json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'currencyType': json['currencyType'] == null ? undefined : json['currencyType'],
        'skuProducts': ((json['skuProducts'] as Array<any>).map(ProductRegisterSkuProductItemFromJSON)),
    };
}

export function ProductRegisterSkuItemToJSON(json: any): ProductRegisterSkuItem {
    return ProductRegisterSkuItemToJSONTyped(json, false);
}

export function ProductRegisterSkuItemToJSONTyped(value?: ProductRegisterSkuItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuCode': value['skuCode'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'businessPlatformId': value['businessPlatformId'],
        'currencyType': value['currencyType'],
        'skuProducts': ((value['skuProducts'] as Array<any>).map(ProductRegisterSkuProductItemToJSON)),
    };
}

